import { formatARS } from '../../utils/currency';
import './ShippingNotice.css';

const ShippingNotice = ({
  variant = 'product',
  freeShippingThreshold = null,
}) => {
  const showThreshold =
    freeShippingThreshold != null && Number(freeShippingThreshold) > 0;

  return (
    <aside className={`shipping-notice shipping-notice--${variant}`} role="note">
      <div className="shipping-notice__icon" aria-hidden="true">
        <i className="fab fa-whatsapp" />
      </div>
      <div className="shipping-notice__body">
        <p className="shipping-notice__title">Envios coordinados por whatsapp*</p>
        <p className="shipping-notice__text">
          Las compras de productos físicos se coordinan por WhatsApp una vez realizada la compra.
        </p>
        {showThreshold && (
          <p className="shipping-notice__threshold">
            Envío gratis a partir de {formatARS(Number(freeShippingThreshold))}
          </p>
        )}
      </div>
    </aside>
  );
};

export default ShippingNotice;
